import { Button } from "@mui/material"
import { createAuthoringSchedule } from "authoring/routes/project/controller/create-authoring-schedule"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useDialog } from "lib/@hooks/useDialog"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import Iconify from "minimals-template/components/Iconify"
import { useParams } from "react-router"
import { CreateScheduleDialog } from "./create-schedule-dialog"

export function CreateScheduleButton({ variant = "contained" }) {
    const { projectId } = useParams()
    const [sentToLegacy] = useBoundValue("sentToLegacy")
    const [archived] = useBoundValue("archived")
    const openCreateScheduleDialog = useDialog(<CreateScheduleDialog />, { maxWidth: "sm" })

    return (
        <Button
            data-cy="create-schedule-button"
            variant={variant}
            color="primary"
            onClick={() => createAuthoringScheduleFromDialog({ projectId, openCreateScheduleDialog })}
            startIcon={<Iconify icon={"ic:round-add"} />}
            sx={{ mt: 2, mb: 3 }}
            disabled={!!sentToLegacy || !!archived}
        >
            Create New Schedule
        </Button>
    )
}

async function createAuthoringScheduleFromDialog({ projectId, openCreateScheduleDialog }) {
    try {
        const newScheduleDetails = await openCreateScheduleDialog()
        if (newScheduleDetails) {
            const createdScheduleId = await createAuthoringSchedule({
                projectId,
                scheduleId: newScheduleDetails.scheduleId?.trim(),
                code: newScheduleDetails.code?.trim(),
                title: newScheduleDetails.title?.trim(),
                legacyScheduleTypes: newScheduleDetails.legacyScheduleTypes ?? [],
                legacyScheduleGroups: newScheduleDetails.legacyScheduleGroups ?? [],
                unitOfMeasure: newScheduleDetails.unitOfMeasure ?? "Nr",
            })
            if (createdScheduleId) {
                successSnackbar("Successfully created schedule")
            } else {
                throw new Error("Failed to create schedule")
            }
        }
    } catch (error) {
        console.error(error)
        errorSnackbar(error?.message ?? "Failed to create schedule")
    }
}
